export const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'bearer ' + window.localStorage.getItem("token")
};
